import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import {
    BASE_URL, getDefaultHeaders, getDynamicHeaders, Entity,
} from '../config';
import {
    ITestId, ITestResult, IQuestionnaire, IPassedTest, ITestList, IGetTests,
} from './types';

export const testsAPI = createApi({
    reducerPath: 'testsAPI',
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
    endpoints: (build) => ({
        getTestList: build.query<ITestList, IGetTests>({
            query: () => ({
                url: `${Entity.tests}`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getTestInfo: build.query<IQuestionnaire, ITestId>({
            query: (payload) => ({
                url: `${Entity.tests}/${payload.id}`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        postTestAnswers: build.mutation<ITestResult, IPassedTest>({
            query: (payload) => ({
                method: 'POST',
                url: `${Entity.tests}/${payload.id}/submit`,
                body: payload.data,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
    }),
});
